var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5542 32.9306C60.2111 30.5875 60.2111 26.7885 62.5542 24.4454L64.6685 22.3311C67.0116 19.9879 70.8106 19.9879 73.1538 22.3311C75.4969 24.6742 75.4969 28.4732 73.1538 30.8164L71.0395 32.9306C68.6964 35.2738 64.8974 35.2738 62.5542 32.9306Z",
    fill: "#F75300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7574 22.2426C25.1005 19.8995 28.8995 19.8995 31.2426 22.2426L73.669 64.6691C76.0122 67.0122 76.0122 70.8112 73.669 73.1543C71.3259 75.4975 67.5269 75.4975 65.1838 73.1543L22.7574 30.7279C20.4142 28.3848 20.4142 24.5858 22.7574 22.2426Z",
    fill: "#111010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2417 73.2425C19.8986 70.8993 19.8986 67.1003 22.2417 64.7572L49.8209 37.178C52.1641 34.8349 55.963 34.8349 58.3062 37.178C60.6493 39.5212 60.6493 43.3201 58.3062 45.6633L30.727 73.2425C28.3839 75.5856 24.5849 75.5856 22.2417 73.2425Z",
    fill: "#111010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.4a4909373fa6b26090ecc6dcd903f50f.svg";
export { ForwardRef as ReactComponent };